import Cartas from "./Cartas";
export default Cartas;
